/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".box-parent[_ngcontent-%COMP%] {\n  background: #ffffff;\n  padding: 20px 50px 50px 50px;\n  border-radius: 10px;\n  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2); }\n\n.rowFix[_ngcontent-%COMP%] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  margin-right: 0px;\n  margin-left: -15px; }"];
export { styles as styles };



// WEBPACK FOOTER //
// /opt/app/src/app/features/dashboard/dashboard-document/dashboard-document.component.scss.shim.ngstyle.js.pre-build-optimizer.js